// ============================================================================
// ADIS 95 - Product Catalog Data
// Extracted from SiteOne Crawler offline export of adis95.fr
// ============================================================================

import { slugify } from "@/lib/utils"

export interface Product {
  slug: string
  name: string
  description: string
  fullDescription?: string
  category: string
  categorySlug: string
  brand: string
  brandSlug: string
  imageUrl: string
  price: null; // Prices are not publicly listed (B2B model)
  specifications?: Record<string, string>
}

export const products: Product[] = [
  {
    slug: "348c-scie-a-ruban-230-v-0-37kw-capacite-de-coupe-o-100mm",
    name: "348C Scie à ruban 230 V, 0.37kW, capacité de coupe 100mm",
    description:
      "Scie à ruban à descente assistée portable pour coupe à sec. Moteur 1 vitesse, capacité de coupe 100 mm en tube. Archet pivotant à 45 D. Ruban guidé par roulements à billes. Étau à serrage rapide. Descente assistée par ressort réglable à 3 positions. Légère (23kg) et équipée d'une poignée.",
    fullDescription:
      "Scie à ruban à descente assistée portable pour coupe à sec. Moteur 1 vitesse, capacité de coupe 100 mm en tube. Archet pivotant à 45 D. Ruban guidé par roulements à billes. Étau à serrage rapide. Descente assistée par ressort réglable à 3 positions. Légère (23kg) et équipée d'une poignée.",
    category: "Machines d'atelier bois et métal",
    categorySlug: "machines-datelier-bois-et-metal",
    brand: "Promac",
    brandSlug: "machines-datelier-bois-et-metal-promac",
    imageUrl:
      "/images/remote/91xnGAxPBQL._SL1500_.jpg",
    price: null,
    specifications: {
      "Puissance": "230V / 0.37 kW",
      "Vitesse du ruban": "45m/min",
      "Dimension du ruban": "170 x 12.7 x 0.64 mm",
      "Archet pivotant": "60 D",
      "Capacité de coupe à 90°": "100 mm (rond), 150 x 100 mm (rectangle)",
      "Capacité de coupe à 45°": "75 mm (rond), 100 x 60 mm (rectangle)",
      "Ouverture étau": "190 mm",
      "Dimensions (LxlxH)": "350 x 800 x 450 mm",
      "Niveau sonore": "70 dB",
      "Poids": "23 kg",
    },
  },
  {
    slug: "abrasif-sbs-sur-support-mousse-ekamant",
    name: "ABRASIF SBS SUR SUPPORT MOUSSE EKAMANT",
    description:
      "SBS est une nouvelle génération d'abrasifs pour le ponçage à main.",
    category: "Abrasifs",
    categorySlug: "abrasifs",
    brand: "Cemon Ekamant",
    brandSlug: "abrasifs-cemon-ekamant",
    imageUrl:
      "/images/remote/2531_1.jpg",
    price: null,
  },
  {
    slug: "affleureuse-makita-3710j-530-w-pince-o-6-mm",
    name: "Affleureuse - MAKITA 3710J - 530 W - pince 6 mm",
    description:
      "Affleureuse 3710J idéale pour le fraisage des bois laminés et de finition. Idéal pour le chanfreinage grâce au guide d'affleurage. Mécanisme à crémaillère pour ajustement précis. Plage de réglage de 0 à 45 degrés.",
    category: "Électroportatifs",
    categorySlug: "electroportatifs",
    brand: "Makita",
    brandSlug: "electroportatifs-makita",
    imageUrl:
      "/images/remote/affleureuse-makita-3710j-530-w-pince-o-6-mm-2.jpg",
    price: null,
  },
  {
    slug: "boite-de-10-plaquettes-carbure-50-x-12-x-1-5",
    name: "BOÎTE DE 10 PLAQUETTES CARBURE 50 X 12 X 1.5",
    description:
      "Ces plaquettes carbure 50 x 12 x 1.5 pour le bois sont vendues par 10. Nuance du carbure de tungstène KRC08, la plus polyvalente, convient pour l'usinage de panneaux de particule, HDF, MDF, bois massif tendre et dur.",
    category: "Fers et plaquettes",
    categorySlug: "fers-et-plaquettes",
    brand: "Ceratizit",
    brandSlug: "fers-et-plaquettes-ceratizit",
    imageUrl:
      "/images/remote/plaquette-carbure-50x12x15-mm.jpg",
    price: null,
    specifications: {
      "Longueur": "50 mm",
      "Largeur": "12 mm",
      "Épaisseur": "1.5 mm",
      "Nombre de coupe": "2",
      "Nuance carbure": "KRC08",
    },
  },
  {
    slug: "chaine-a-mortaiser-16-mm-48-maillons-pas-b",
    name: "Chaîne à mortaiser - 16 mm - 48 maillons - pas B",
    description:
      "Chaîne à mortaiser composée d'une chaîne, un guide, un pignon, pour effectuer des mortaises de dimension diverses dans les bois. La garniture se monte sur des machines à mortaiser stationnaires ou portatives.",
    category: "Outillages Divers",
    categorySlug: "outillages-divers",
    brand: "Jaguar",
    brandSlug: "outillages-divers-jaguar",
    imageUrl:
      "/images/remote/chaine-de-mortaiseuse.jpg",
    price: null,
  },
  {
    slug: "chaine-tronconneuse-oregon-95vpx056e-pas-325-jauge-050-1-30-mm-56-maillons-56-entraineurs",
    name: "Chaîne tronçonneuse OREGON 95VPX056E, pas .325, jauge .050, 1.30 mm, 56 maillons, 56 entraîneurs",
    description:
      "Chaîne tronçonneuse OREGON 95VPX056E, pas .325, jauge .050, 1.30 mm, 56 maillons, 56 entraîneurs.",
    category: "Outillages Divers",
    categorySlug: "outillages-divers",
    brand: "MFLS Forézienne",
    brandSlug: "outillages-divers-mfls-forezienne",
    imageUrl:
      "/images/remote/chaine-tronconneuse-oregon-95vpx056e-pas-325-jauge-050-13-mm-56-maillons-56-entraineurs-1.jpg",
    price: null,
    specifications: {
      "Pas": ".325",
      "Jauge": ".050 / 1.30 mm",
      "Maillons": "56",
      "Entraîneurs": "56",
    },
  },
  {
    slug: "cloueur-pneumatique-ja-30-p1-pour-minibrads-13-a-30-mm-en-coffret-box-1-101b2130b-alsafix",
    name: "Cloueur pneumatique JA-30 P1 pour minibrads 13 à 30 mm en coffret Box 1 - 101B2130B - Alsafix",
    description:
      "Cloueur pour la fixation de parcloses, lambris, bureaux, bars, bateaux, roulottes, cercueils. Convient aux pointes minibrads JA. Livré en coffret Box-1.",
    category: "Électroportatifs",
    categorySlug: "electroportatifs",
    brand: "Alsafix",
    brandSlug: "electroportatifs-alsafix",
    imageUrl:
      "/images/remote/cloueur-pneumatique-ja-30-p1-pour-minibrads-13-a-30-mm-en-coffret-box-1-101b2130b-a.jpg",
    price: null,
    specifications: {
      "Pression d'utilisation": "4-7 bars",
      "Consommation d'air": "0,37 l/coup",
      "Capacité du magasin": "130",
      "Projectiles maxi": "30 mm",
      "Filetage/raccord": "1/4\"",
      "Poids net": "0,87 Kg",
      "Dimensions": "L 247 x 42 x H 165 mm",
      "Garantie": "1 an (hors pièces d'usures)",
    },
  },
  {
    slug: "cloueur-senco-fusionf18-18-v-li-ion-15-ah-finettes-o-12-mm",
    name: "Cloueur - SENCO FUSIONF18 - 18 V Li-ion - 1,5 Ah - Finettes 1,2 mm",
    description:
      "Le cloueur à brads FUSION F18 combine le meilleur du pneumatique et de la technologie sans fil pour vous apporter puissance et autonomie. Tir instantané comme en pneumatique. Rechargement de la batterie en 15 mn (80%). Charge complète atteinte en 45 mn. Jusqu'à 600 tirs par charge.",
    fullDescription:
      "Finition : moulures et baguettes. Encadrement. Pare close. Tiroirs, petits assemblages. Fonctionnement restrictif ou à touche. Sélecteur du mode tir. Pas d'explosion et donc pas d'encrassement. Pas de tuyau d'air. Batterie sans effet mémoire. Éclairage zone de travail par led.",
    category: "Électroportatifs",
    categorySlug: "electroportatifs",
    brand: "Kyocera - Senco",
    brandSlug: "electroportatifs-kyocera-senco",
    imageUrl:
      "/images/remote/cloueur-senco-fusionf18-18-v-li-ion-15-ah-finettes-o-12-mm.jpg",
    price: null,
    specifications: {
      "Tension": "18 V Li-ion",
      "Capacité batterie": "1,5 Ah",
      "Diamètre finettes": "1,2 mm",
      "Rechargement 80%": "15 mn",
      "Charge complète": "45 mn",
      "Tirs par charge": "jusqu'à 600",
    },
  },
  {
    slug: "combi-pneumatique-mini-brad-et-agrafes-kmr-12100540",
    name: "COMBI PNEUMATIQUE MINI-BRAD ET AGRAFES KMR 12100540",
    description:
      "Clouage de brads de 16 à 55mm et d'agrafes type C de 12 à 41mm, réglage d'enfoncement, déclenchement en mode coup par coup ou rafale. Ultra-léger et robuste, poids 1.2kg. Pointeur lumineux, ouverture du bec pour désenrayement rapide. Poignée en caoutchouc.",
    category: "Électroportatifs",
    categorySlug: "electroportatifs",
    brand: "KMR",
    brandSlug: "electroportatifs-kmr",
    imageUrl:
      "/images/remote/combi-pneumatique-mini-brad-et-agrafes-kmr-12100540.jpg",
    price: null,
    specifications: {
      "Brads": "16 à 55 mm",
      "Agrafes type C": "12 à 41 mm",
      "Poids": "1.2 kg",
    },
  },
  {
    slug: "compresseur-electrique-a-piston-insonorises-serie-b009449030",
    name: "Compresseur électrique à piston insonorisé série B009449030",
    description:
      "Les compresseurs de la série B offrent une alternative aux utilisateurs qui portent une attention particulière au niveau sonore. Ils sont les plus silencieux du marché pour des compresseurs à pistons.",
    category: "Compresseurs",
    categorySlug: "compresseurs",
    brand: "Guernet",
    brandSlug: "compresseurs-guernet",
    imageUrl:
      "/images/remote/compresseurs-electriques-a-pistons-insonorises-serie-b-009449030-product_zoom.jpg",
    price: null,
  },
  {
    slug: "compresseur-mural-abac-xpn-015",
    name: "Compresseur mural ABAC XPN 015",
    description:
      "Le nouveau compresseur d'air ABAC XPN 015 est un concept unique en son genre, nominé pour la finale des grands prix de l'innovation automobile Equip Auto 2019. Compresseur à piston 1,5 CV, sans huile et sans réservoir. Enrouleur avec tuyau intégré de 10 mètres, rétractable automatique.",
    category: "Compresseurs",
    categorySlug: "compresseurs",
    brand: "ABAC",
    brandSlug: "compresseurs-abac",
    imageUrl:
      "/images/remote/ABAC-XPN-015.png",
    price: null,
    specifications: {
      "Puissance": "1,5 CV",
      "Débit": "9,6 m³/heure",
      "Pression": "8 bars",
      "Niveau sonore": "68 dB",
      "Poids": "8,5 kg",
      "Alimentation": "230 V mono-moulée",
      "Lubrification": "sans huile",
      "Longueur tuyau": "10 mètres",
    },
  },
  {
    slug: "embout-pour-chaine-a-mortaiser-dimensions-8-12-x-30-b-4",
    name: "Embout pour chaîne à mortaiser Dimensions : 8-12 x 30-B-4",
    description:
      "Embouts brevetés pour les guides disponibles dans toutes les mesures de guide produite dans la série A, B et fournis déjà montés et rodés. Permettent la réparation rapide du guide en 5 ou 10 minutes maximum.",
    category: "Outillages Divers",
    categorySlug: "outillages-divers",
    brand: "Leman",
    brandSlug: "outillages-divers-leman",
    imageUrl:
      "/images/remote/embout-pour-chaine-a-mortaiser.jpg",
    price: null,
  },
  {
    slug: "fers-de-degauchisseuses-et-raboteuses-type-hss-18",
    name: "FERS DE DÉGAUCHISSEUSES ET RABOTEUSES Type : HSS 18%",
    description:
      "Fer en acier super-rapide (18% tungstène et 4% chrome). Très haute tenue de coupe dans tous les bois tendres ou durs. Sur raboteuses, dégauchisseuses, 4 faces.",
    category: "Fers et plaquettes",
    categorySlug: "fers-et-plaquettes",
    brand: "Jaguar",
    brandSlug: "fers-et-plaquettes-jaguar",
    imageUrl:
      "/images/remote/PHARE-6.jpg",
    price: null,
    specifications: {
      "Type": "HSS 18%",
      "Composition": "18% tungstène, 4% chrome",
      "Usage": "Raboteuses, dégauchisseuses, 4 faces",
    },
  },
  {
    slug: "fraise-scie-o315-x-3-0-x-40-pas-4-variable",
    name: "Fraise scie 315 x 3.0 x 40 Pas 4 VARIABLE",
    description:
      "Fraises scies en HSS-Dmo5 hautes tolérances traitement de surface par oxydation ou revêtu TiN. Livrées en dentures Acme et Heller avec angles de coupe de 18 +/- 2 degrés et de dépouille de 10 +/- 2 degrés.",
    category: "Fraises scie",
    categorySlug: "fraises-scie",
    brand: "SDC Julia",
    brandSlug: "fraises-scie-sdc-julia",
    imageUrl:
      "/images/remote/fraise-scie-vapo-hss-dmo5-d-275-x-al-40-mm-pas-de-4-x-220-dents-ep-2-5-mm-pour-l-acier-122-274-2540-leman-24423244-e1584108502442.jpg",
    price: null,
    specifications: {
      "Diamètre": "315 mm",
      "Épaisseur": "3.0 mm",
      "Alésage": "40 mm",
      "Pas": "4 variable",
      "Matériau": "HSS-Dmo5",
    },
  },
  {
    slug: "jeu-de-2-contre-fers-profiles-ht-50-mm-n203-enture-multiple-4-mm-856-203-leman",
    name: "Jeu de 2 contre-fers profilés Ht. 50 mm N.203 Enture multiple 4 mm - 856.203 - Leman",
    description:
      "Fer de toupie profilé hauteur 50 mm, épaisseur 5,5 mm (le jeu de 2). Ces fers se montent uniquement sur un porte-outils hauteur 50 mm entraxe 24 mm.",
    fullDescription:
      "Pour un porte-outils standard à 2 coupes = achat uniquement de la paire de fers. Pour un porte-outils de type sécurité à 2 fers (ceux qui coupent) + 2 contre-fers (ceux qui sont noirs et qui ne coupent pas) = achat de la paire de fers + de la paire de contre-fers. Les porte-outils de type sécurité hauteur 50 mm n'acceptent que les fers de toupie hauteur 50 mm car il faut une épaisseur de 5,5 mm.",
    category: "Fers et plaquettes",
    categorySlug: "fers-et-plaquettes",
    brand: "Leman",
    brandSlug: "fers-et-plaquettes-leman",
    imageUrl:
      "/images/remote/jeu-de-2-contre-fers-profiles-ht-50-mm-n203-enture-multiple-4-mm-856203-leman.jpg",
    price: null,
    specifications: {
      "Hauteur": "50 mm",
      "Épaisseur": "5,5 mm",
      "Entraxe": "24 mm",
      "Référence": "856.203",
    },
  },
  {
    slug: "lame-acier-d-700-x-ep-dents-4-x-al-45-mm-96-dents-couchees",
    name: "Lame acier D. 700 x ép. 4 x Al. 45 mm — 96 dents couchées (Jaguar)",
    description:
      "Lame de scie circulaire acier Jaguar — Diamètre 700 x épaisseur dents 4 x Alésage 45 mm. 96 dents couchées.",
    category: "Lames circulaires acier",
    categorySlug: "lames-circulaires-acier",
    brand: "Jaguar",
    brandSlug: "lames-circulaires-acier-jaguar",
    imageUrl:
      "/images/remote/Lames-de-scie-acier.jpg",
    price: null,
    specifications: {
      "Diamètre": "700 mm",
      "Épaisseur dents": "4 mm",
      "Alésage": "45 mm",
      "Nombre de dents": "96",
      "Type de dents": "couchées",
    },
  },
  {
    slug: "lame-acier-d-700-x-ep-dents-4-x-al-45-mm-96-dents-couchees-2",
    name: "Lame acier D. 700 x ép. 4 x Al. 45 mm — 96 dents couchées (MFLS Forézienne)",
    description:
      "Lame de scie circulaire acier MFLS Forézienne — Diamètre 700 x épaisseur dents 4 x Alésage 45 mm. 96 dents couchées.",
    category: "Lames circulaires acier",
    categorySlug: "lames-circulaires-acier",
    brand: "MFLS Forézienne",
    brandSlug: "lames-circulaires-acier-mfls-forezienne",
    imageUrl:
      "/images/remote/lame-acier-d-700-x-ep-dents-4-x-al-45-mm-96-dents-couchees.jpg",
    price: null,
    specifications: {
      "Diamètre": "700 mm",
      "Épaisseur dents": "4 mm",
      "Alésage": "45 mm",
      "Nombre de dents": "96",
      "Type de dents": "couchées",
    },
  },
  {
    slug: "lame-carbure-machine-portative-o160-x2-2-1-6-ales-20-z24-dents-alternees",
    name: "LAME CARBURE machine portative 160 x2.2/1.6 - Alés 20 - Z=24 dents alternées",
    description:
      "Cette lame est utilisée pour des coupes en long et en travers pour du bois massif. Lame compatible avec la TS 55 Festool.",
    category: "Lames circulaires carbure",
    categorySlug: "lames-circulaires-carbure",
    brand: "MFLS Forézienne",
    brandSlug: "lames-circulaires-carbure-mfls-forezienne",
    imageUrl:
      "/images/remote/lame.jpg",
    price: null,
    specifications: {
      "Diamètre": "160 mm",
      "Épaisseur": "2.2/1.6 mm",
      "Alésage": "20 mm",
      "Nombre de dents": "24",
      "Type de dents": "alternées",
    },
  },
  {
    slug: "lame-carbure-o-300-x-3-2-260-ales-30-z96-plate-trapezoidale-pt-negative",
    name: "LAME CARBURE 300 x 3.2/2,60 - alés 30 Z96 plate trapézoïdale (PT) négative",
    description:
      "Avance manuelle et mécanique. Cette lame est utilisée pour coupe de profilés aluminium, PVC, coupe sur chantier de panneaux composites de façade, métaux non ferreux. Lame utilisée sur tronçonneuse, scie à onglet, scie à format, scie radiale, scie pendulaire, scie électroportative, CNC.",
    category: "Lames circulaires carbure",
    categorySlug: "lames-circulaires-carbure",
    brand: "AKE",
    brandSlug: "lames-circulaires-carbure-ake",
    imageUrl:
      "/images/remote/phare-1.png",
    price: null,
    specifications: {
      "Diamètre": "300 mm",
      "Épaisseur": "3.2/2,60 mm",
      "Alésage": "30 mm",
      "Nombre de dents": "96",
      "Type de dents": "plate trapézoïdale (PT) négative",
    },
  },
  {
    slug: "lame-carbure-o305-x3-2-2-2-ales30-z66-dents-gouge-0-ppt-melody-micron-super-plus",
    name: "LAME CARBURE 305 x3.2/2.2 Alés30 - Z=66 dents GOUGE 0 PPT Melody Micron Super Plus",
    description:
      "Bruit atténué. Cette lame est utilisée pour des coupes de finition à l'unité pour du mélaminé et stratifié. Lame utilisée sur scie à panneaux verticales et scie à format.",
    category: "Lames circulaires carbure",
    categorySlug: "lames-circulaires-carbure",
    brand: "AKE",
    brandSlug: "lames-circulaires-carbure-ake",
    imageUrl:
      "/images/remote/phare-1.png",
    price: null,
    specifications: {
      "Diamètre": "305 mm",
      "Épaisseur": "3.2/2.2 mm",
      "Alésage": "30 mm",
      "Nombre de dents": "66",
      "Type de dents": "GOUGE 0 PPT",
      "Gamme": "Melody Micron Super Plus",
    },
  },
  {
    slug: "lame-de-scie-a-ruban-metal-1470mm-x-13-x-065-mm-x-z18-r",
    name: "Lame de scie à ruban métal 1470mm x 13 x 0,65 mm x Z=18 R",
    description:
      "Lame de scie à ruban métal prête à l'emploi (Soudée, Affûtée, Avoyée) conçue pour la coupe d'acier, métaux.",
    category: "Rubans",
    categorySlug: "rubans",
    brand: "Jaguar",
    brandSlug: "rubans-jaguar",
    imageUrl:
      "/images/remote/lame-de-scie-a-ruban-metal.jpg",
    price: null,
    specifications: {
      "Longueur": "1470 mm",
      "Largeur": "13 mm",
      "Épaisseur": "0,65 mm",
      "Nombre de dents": "18 R",
    },
  },
  {
    slug: "lame-ruban-forezienne-5600x15x07-mm-pas-8-mm",
    name: "Lame ruban - FORÉZIENNE - 5600x15x0,7 mm - pas 8 mm",
    description:
      "L'acier FORESTILL est spécialement conçu pour la fabrication de lames de scie à ruban. Élaboré à partir de minerai très pur, sa fabrication répond à un cahier des charges très strict (qualité de la coulée, laminage à chaud puis à froid, trempes et revenus multiples).",
    category: "Rubans",
    categorySlug: "rubans",
    brand: "MFLS Forézienne",
    brandSlug: "rubans-mfls-forezienne",
    imageUrl:
      "/images/remote/lame-ruban-forezienne.jpg",
    price: null,
    specifications: {
      "Dimensions": "5600 x 15 x 0,7 mm",
      "Pas": "8 mm",
      "Acier": "FORESTILL",
    },
  },
  {
    slug: "lamello-fraiseuse-zeta-p2",
    name: "LAMELLO Fraiseuse ZETA P2",
    description:
      "Lot promotion LAMELLO : Fraiseuse ZETA P2, 3 types de connecteur, fraise diamant. Kit de démarrage complet dans un set.",
    fullDescription:
      "Fraiseuse P-SYSTEM ZETA P2, fraise diamant, 3 types de connecteurs P-System (clamex, tenso et divario), outils de montage, gabarit de marquage avec foret. La machine Zeta P2 pour le rainurage profilé est l'outil de référence pour l'ancrage à engagement positif des éléments d'assemblage de la famille Clamex P. Idéal pour la menuiserie sans équipement stationnaire. Encollage rapide pour l'assemblage des angles. Matériaux et panneaux en bois ainsi que des matériaux composites en Corian ou HPL.",
    category: "Électroportatifs",
    categorySlug: "electroportatifs",
    brand: "Lamello",
    brandSlug: "electroportatifs-lamello",
    imageUrl:
      "/images/remote/lot-promotion-lamello-fraiseuse-zeta-p2-3-types-de-connecteur-fraise-diamant.jpg",
    price: null,
  },
  {
    slug: "lames-de-scie-circulaires-carbure-serie-mince-affutage-biseau-alterne",
    name: "Lames de scie circulaires carbure série mince affûtage biseau alterné",
    description:
      "Pour bois massif en faibles épaisseurs, panneaux nus ou revêtus, à l'unité ou en paquets jusqu'à 40mm d'épaisseur. Pour réaliser des coupes requérant un trait de scie mince. Sur scies à format, toupie, avec avance manuelle ou automatique.",
    category: "Lames circulaires carbure",
    categorySlug: "lames-circulaires-carbure",
    brand: "Jaguar",
    brandSlug: "lames-circulaires-carbure-jaguar",
    imageUrl:
      "/images/remote/Capture-d%E2%80%99%C3%A9cran-2016-02-11-%C3%A0-16.29.18-1024x695-1.png",
    price: null,
  },
  {
    slug: "leman-porte-outils-a-rainer-extensible-160x50x4-75-z8v4-950-9-160-51-47",
    name: "Leman - Porte-outils à rainer extensible 160x50x4/7,5 z8+V4 - 950.9.160.51.47",
    description:
      "Porte-outils extensible par bagues fournies pour rainurer les panneaux massifs, bois exotiques, agglomérés et contreplaqués.",
    category: "Outillages Bois",
    categorySlug: "outillages-bois",
    brand: "Leman",
    brandSlug: "outillages-bois-leman",
    imageUrl:
      "/images/remote/Leman_950.9.160.51.47.jpg",
    price: null,
    specifications: {
      "Dimensions": "160 x 50 mm",
      "Extension": "4 à 7,5 mm",
      "Dents": "z8+V4",
      "Référence": "950.9.160.51.47",
    },
  },
  {
    slug: "meche-a-bois-a-spire-unique-queue-hexagonale",
    name: "Mèche à bois à spire unique queue hexagonale",
    description:
      "Mèche à bois en acier pour bois. Tolérance sur diamètre : +0/+0.1. Protection anti-corrosion. Pointe de centrage.",
    category: "Outillages Divers",
    categorySlug: "outillages-divers",
    brand: "Alpha Coupe",
    brandSlug: "outillages-divers-alpha-coupe",
    imageUrl:
      "/images/remote/meche-a-bois-a-spire-unique-queue-hexagonale-.jpg",
    price: null,
    specifications: {
      "Longueur totale": "600 mm",
      "Longueur utile": "530 mm",
      "Diamètre": "20 mm",
      "Queue": "hexagonale",
    },
  },
  {
    slug: "meche-a-defoncer-cmt-17408011-o-8-x-l-20-x-l-55-mm-q8",
    name: "Mèche à défoncer - CMT 17408011 - 8 x l 20 x L 55 mm - Q8",
    description:
      "Pour percer et détourer du bois massif et dérivés, laminés et matériaux plastiques. À utiliser sur mandrins ou adaptateurs pour les centres d'usinage, défonceuses et pantographes CNC. Carbure super micrograin de très haute qualité. 2 tranchants avec rectification radiale hw (z2). 1 tranchant hw (z1) à percer. Queue de 8 mm.",
    category: "Outillages Bois",
    categorySlug: "outillages-bois",
    brand: "CMT",
    brandSlug: "outillages-bois-cmt",
    imageUrl:
      "/images/remote/M%C3%A8ches-de-d%C3%A9fonceuse.jpg",
    price: null,
    specifications: {
      "Diamètre": "8 mm",
      "Longueur utile": "20 mm",
      "Longueur totale": "55 mm",
      "Queue": "8 mm",
      "Tranchants": "2 (z2) + 1 (z1)",
      "Carbure": "super micrograin",
    },
  },
  {
    slug: "nettoyant-pour-colle-virutex-8599694-netspray-400-ml",
    name: "Nettoyant pour colle - VIRUTEX 8599694 - NETSPRAY - 400 ml",
    description:
      "Un nettoyant polyvalent très efficace pour le nettoyage des restes de colle. Dissout saleté, huile, graisse, cire, goudron, caoutchouc, résidus de silicone ou de colle. Également un dégraissant efficace. Élimine les résidus d'étiquettes auto-adhésives.",
    category: "Électroportatifs",
    categorySlug: "electroportatifs",
    brand: "Virutex",
    brandSlug: "electroportatifs-virutex",
    imageUrl:
      "/images/remote/nettoyant-pour-colle-virutex-8599694-netspray-400-ml.jpg",
    price: null,
    specifications: {
      "Contenance": "400 ml",
      "Référence": "8599694",
    },
  },
  {
    slug: "outil-oscillant-fein-fsc500qsl-supercut-starlockmax-450-w",
    name: "Outil oscillant - FEIN FSC500QSL - Supercut - StarlockMax - 450 W",
    description:
      "Machine oscillante avec système de serrage rapide pour l'aménagement et la rénovation.",
    category: "Électroportatifs",
    categorySlug: "electroportatifs",
    brand: "Fein",
    brandSlug: "electroportatifs-fein",
    imageUrl:
      "/images/remote/outil-oscillant-fein-fsc500qsl-supercut-starlockmax-450-w.jpg",
    price: null,
    specifications: {
      "Puissance": "450 W",
      "Système": "StarlockMax",
      "Gamme": "Supercut",
    },
  },
  {
    slug: "porte-outils-elbe-pc009035-a-calibrer-o-80x85x50-mm",
    name: "Porte-outils - ELBE PC009035 - à calibrer - 80x85x50 mm",
    description:
      "Pour dresser et calibrer des pièces avec l'utilisation d'un guide à bille. Corps en acier, limité au niveau de l'épaisseur des copeaux, équipé de plaquettes réversibles carbure. Porte outils à avance manuelle. Livré avec roulements à billes.",
    category: "Outillages Bois",
    categorySlug: "outillages-bois",
    brand: "MFLS Forézienne",
    brandSlug: "outillages-bois-mfls-forezienne",
    imageUrl:
      "/images/remote/porte-outils-elbe-pc009035-a-calibrer-o-80x85x50-mm.jpg",
    price: null,
    specifications: {
      "Dimensions": "80 x 85 x 50 mm",
      "Référence": "PC009035",
      "Plaquettes": "réversibles carbure",
    },
  },
  {
    slug: "porte-outils-pour-couteaux-crantes-z-egale-4-sans-fers",
    name: "Porte-Outils pour couteaux crantés Z égale 4, sans fers",
    description:
      "Porte-Outils pour couteaux crantés Z égale 4, sans fers. Référence 3542.370.00.",
    category: "Outillages Bois",
    categorySlug: "outillages-bois",
    brand: "AKE",
    brandSlug: "outillages-bois-ake",
    imageUrl:
      "/images/remote/porte-outils-pour-couteaux-crantes-z-4-sans-fers.jpg",
    price: null,
    specifications: {
      "Nombre de couteaux": "Z = 4",
      "Référence": "3542.370.00",
      "Fers": "sans fers (vendus séparément)",
    },
  },
  {
    slug: "scie-stationnaire-tks-80-ebs",
    name: "Scie stationnaire TKS 80 EBS",
    description:
      "La scie stationnaire TKS 80 EBS-Set FESTOOL : plus de sécurité, plus de flexibilité et peu encombrant.",
    category: "Électroportatifs",
    categorySlug: "electroportatifs",
    brand: "Festool",
    brandSlug: "electroportatifs-festool",
    imageUrl:
      "/images/remote/electroportatif.jpg",
    price: null,
  },
  {
    slug: "serre-joint-a-pompe",
    name: "Serre joint à pompe",
    description:
      "Serre-joint à pompe avec tête en fonte renforcée. Frein anti glissant en acier trempé et denté. Tige en acier laminé et calibrée. Piston de serrage en une seule pièce en acier. Double vis filet métrique, avec manche en croix. Puissance de serrage 9 000 N.",
    category: "Serrages",
    categorySlug: "serrages",
    brand: "Leman",
    brandSlug: "serrages-leman",
    imageUrl:
      "/images/remote/serrejoint-a-pompe.jpg",
    price: null,
    specifications: {
      "Puissance de serrage": "9 000 N",
      "Tête": "fonte renforcée",
      "Tige": "acier laminé et calibrée",
    },
  },
  {
    slug: "serre-joint-tpal",
    name: "Serre joint TPAL",
    description: "Serre joint TPAL.",
    category: "Serrages",
    categorySlug: "serrages",
    brand: "Piher",
    brandSlug: "serrages-piher",
    imageUrl:
      "/images/remote/serre-joint-tpal.jpg",
    price: null,
  },
  {
    slug: "sianet-abrasif-reticule-de-haute-performance",
    name: "SIANET Abrasif réticulé de haute performance",
    description:
      "Abrasif réticulé de haute performance. Type de grain : Oxyde alumine semi-friable. Support : Toile. Épandage : Électrostatique. Liant : Résine synthétique.",
    category: "Abrasifs",
    categorySlug: "abrasifs",
    brand: "Sia Abrasif",
    brandSlug: "abrasifs-sia-abrasif",
    imageUrl:
      "/images/remote/images-1.jpg",
    price: null,
    specifications: {
      "Type de grain": "Oxyde alumine semi-friable",
      "Support": "Toile",
      "Épandage": "Électrostatique",
      "Liant": "Résine synthétique",
    },
  },
  {
    slug: "touret-daffutage-tormek-t-8-200-w",
    name: "Touret d'affûtage - TORMEK T-8 - 200 W",
    description:
      "Le spécialiste de l'affûtage. Tormek est un fabricant suédois tourné exclusivement vers l'affûtage des outils tranchants. Ses machines d'affûtage sont conviviales et donnent de parfaits résultats, très appréciées des professionnels du bois (charpentiers, menuisiers, tourneurs, sculpteurs). Avec le système Tormek, la durée de vie de vos outils sera largement étendue.",
    fullDescription:
      "La machine à affûter Tormek T-8 optimise la précision grâce à son bâti révolutionnaire entièrement moulé. Ce nouveau design, associé à plusieurs détails élaborés, vous apporte les meilleures conditions possibles pour un affûtage réussi et d'excellents résultats. Retrouvez les produits Tormek : Tourets d'affûtage, gabarits et accessoires, meules et cuirs de démorfilage.",
    category: "Outillages Bois",
    categorySlug: "outillages-bois",
    brand: "MFLS Forézienne",
    brandSlug: "outillages-bois-mfls-forezienne",
    imageUrl:
      "/images/remote/touret-d-affutage-tormek-t-8-200-w.jpg",
    price: null,
    specifications: {
      "Puissance": "200 W",
      "Marque": "Tormek",
      "Modèle": "T-8",
      "Origine": "Suède",
    },
  },
]

// Helper: get products by category slug
export function getProductsByCategory(categorySlug: string): Product[] {
  return products.filter((p) => p.categorySlug === categorySlug)
}

// Helper: get products by brand slug
export function getProductsByBrand(brandSlug: string): Product[] {
  return products.filter((p) => p.brandSlug === brandSlug)
}

// Helper: get product by slug
export function getProductBySlug(slug: string): Product | undefined {
  return products.find((p) => p.slug === slug)
}

// Helper: get all unique categories
export function getUniqueCategories(): string[] {
  return [...new Set(products.map((p) => p.category))]
}

// Helper: get all unique brands
export function getUniqueBrands(): string[] {
  return [...new Set(products.map((p) => p.brand))]
}

// Helper: get products by brand display name (exact match)
export function getProductsByBrandDisplayName(brandName: string): Product[] {
  return products.filter((p) => p.brand === brandName)
}

// Helper: get all unique brand info for /marque/[brand] routes
export function getAllBrandInfo(): {
  brandName: string
  slug: string
  productCount: number
  categories: string[]
}[] {
  const map = new Map<string, { count: number; categories: Set<string> }>()
  for (const p of products) {
    const existing = map.get(p.brand) || { count: 0, categories: new Set<string>() }
    existing.count++
    existing.categories.add(p.category)
    map.set(p.brand, existing)
  }
  return Array.from(map.entries())
    .map(([brandName, data]) => ({
      brandName,
      slug: slugify(brandName),
      productCount: data.count,
      categories: Array.from(data.categories),
    }))
    .sort((a, b) => b.productCount - a.productCount)
}
